<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">添加功能区</div>   
     <form-list ref="addribbon" :projectList="projectList" :n="n" ></form-list>    
  </Modal>
</template>
<script type="text/ecmascript-6">
import FormList from './FormItem';
import { addFunctionalarea } from "api/functionalArea";
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    projectList:{
      type:Array,
      default:null
    }
  },
  components: {
        FormList  
    },
 data () {
 return {
  show:false,
  loading:true
 };
 },
 watch:{
   n(val){
     this.show = true;
   }
 },
 methods:{
   changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
  },
   save(){
    let params = this.$refs['addribbon'].formValidate();
    if(!params){
      this.changeLoading()
      return
    }
    addFunctionalarea(params).then(res => {       
      this.changeLoading();
      this.$Message.success('添加成功');
      this.$emit('refresh')
      this.show = false;
    }).catch(error => {
      this.changeLoading(); 
    })   
   }
 }
}
</script>
